<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left">USUÁRIOS</v-alert>
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn @click="novo()" color="topEnviados" dark>
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsCategoria"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-2"
      >
        <template v-slot:item.status="{ item }">
          <v-switch
            color="green"
            :label="`${checkStatus(item.status)}`"
            @change="mudarStatus(item.id,item.status)"
            v-model="item.status"
            value-true="1"
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            @click="dialogPermissao = true;listaPermissoesUser(item.permissoes , item.id)"
            color="success"
          >
            <v-icon>lock_open</v-icon>Permissões
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Exclusão</v-card-title>
          <v-card-text>Deseja excluir esse usuário?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" class="white--text" @click="dialogCancel = false">Não</v-btn>
            <v-btn color="green darken-1" class="white--text" @click="deleta(selItem)">Sim</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogPermissao" persistent max-width="1248">
        <v-card>
          <v-card-title>Permissões</v-card-title>
          <v-card-text style="font-size:10px" class="d-flex flex-wrap">
            <div
              cols="6"
              style="font-size:9px;width:340px;padding:0.5rem"
              v-for="(permissao, i) in permissoes"
              :key="i"
            >
              <v-checkbox
                ripple
                color="success"
                :value="permissao.id"
                v-model="chk_permissoes"
                :label="permissao.descricao"
              ></v-checkbox>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" class="white--text" @click="dialogPermissao = false">Sair</v-btn>
            <v-btn
              color="success darken-1"
              class="white--text"
              @click="gravarPermissoes();dialogPermissao = false"
            >Gravar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogCadastro" persistent max-width="40%">
      <v-card>
        <v-card-title class>Cadastro de Usuário</v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="8" md="8" lg="8">
                <v-text-field v-model="usuario.nome" label="nome" filled dense clearable required></v-text-field>
              </v-col>
              <v-col cols="8" md="8" lg="8">
                <v-text-field v-model="usuario.email" label="email" filled dense clearable required></v-text-field>
              </v-col>

              <v-col cols="2" md="2" lg="2"></v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="success" @click="gravar()" class="mr-4">
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <v-btn @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      <v-btn @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String
  },
  data: () => ({
    singleLine: true,
    footerProps: { "items-per-page-options": [30, 50, 100] },
    categoria: {
      descricao: ""
    },
    botao_sucesso: "botao_sucesso",
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    acesso: [],
    error: "error",
    tempo: 5000,
    mode: "vertical",
    snackbar: false,
    textSnack: "",
    multiline: true,
    sucesso: "botao_sucesso",
    snackbarSuccess: false,
    chk_permissoes: [],
    textSucesso: "",

    sheet: false,

    itemsUnidade: ["UN", "PC", "KG"],

    filtroProduto: "Produtos ",
    sv: false,
    carregaCep: false,
    dialogPermissao: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCategoria: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    permissoes: [],
    selItem: "",
    selUser: "",
    usuario: {
      id: "",
      nome: "",
      email: "",
      status: ""
    },

    headers: [
      {
        text: "Nome",
        align: "left",
        sortable: true,
        value: "nome"
      },
      {
        text: "email",
        align: "left",
        sortable: true,
        value: "email"
      },
      {
        text: "Status",
        value: "status",
        align: "left"
      },

      { text: "Ação", value: "action", sortable: false }
    ]
  }),
  watch: {},
  mounted() {
    this.buscaUsuarios();
    this.buscaListaPermissoes();
  },
  methods: {
    async gravarPermissoes() {
      axios
        .post(`/grupo/user/config_permissoes`, {
          id: this.selUser,
          permissoes: this.chk_permissoes
        })
        .then(response => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Permissões alteradas com sucesso!";
            this.buscaUsuarios();
            this.dialogPermissao = false;
          }
        });
    },

    async status() {
      axios
        .post(`/grupo/user/status`, {
          id: this.selUser,
          status: this.chk_permissoes
        })
        .then(response => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Permissões alteradas com sucesso!";
            this.buscaUsuarios();
            this.dialogPermissao = false;
          }
        });
    },

    listaPermissoesUser(permissoes, id) {
      this.chk_permissoes = permissoes;
      this.selUser = id;
    },
    checkStatus(valor) {
      if (valor == 1) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },

    limpaCampos() {
      this.usuario.nome = "";
      this.usuario.email = "";
    },

    novo() {
      this.dialogCadastro = true;
      this.limpaCampos();
    },

    excluirUser(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },
    mudarStatus(id_user, status) {
      axios
        .post(`/grupo/user/status`, { id: id_user, status: status })
        .then(response => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.buscaUsuarios();
          }
        });
    },

    buscaListaPermissoes() {
      this.loading_table = true;
      axios.get(`/grupo/lista_todas_permissoes`).then(response => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.permissoes = response.data;
        }
      });
    },

    buscaUsuarios() {
      this.loading_table = true;
      axios.get(`/grupo/user/lista_grupo`).then(response => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCategoria = response.data;
        }
      });
    },

    gravar() {
      axios
        .post(`/grupo/user/criar`, this.usuario)
        .then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Usúario incluido com sucesso!";
            this.buscaUsuarios();

            this.limpaCampos();
          }
        })
        .catch(e => {
          if (e.response.data.error) {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          } else {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          }
        });
    }
  }
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-data-table td {
  font-size: 0.685rem !important;
}

.v-messages {
  min-height: 0px !important;
}
</style>
